import windowUtil from '@/utils/window'

export default {
  data () {
    return {
      reached: false,
      preload: false,
      inView: false,
      inViewMostly: false
    }
  },
  methods: {
    onScroll () {
      const el = this.$el
      if (!el || !el.attributes) {
        return
      }

      const windowHeight = window.innerHeight
      const rect = el.getBoundingClientRect()
      const elTop = rect.top
      const elHeight = rect.height

      // If the element is smaller than the window height,
      // it is considered 'reached' when half of the element is visible and
      // otherwise the element is 'reached' when the element covers at least half the viewport
      const threshold = elHeight < windowHeight ? (windowHeight - 0.5 * elHeight) : 0.5 * windowHeight

      this.reached = elTop < threshold
      this.preload = window.pageYOffset > elTop - (windowHeight * 1.5)
    },
    onScrollDirect () {
      const el = this.$el
      if (!el || !el.attributes) {
        return
      }

      const windowHeight = window.innerHeight
      const rect = el.getBoundingClientRect()
      const elTop = rect.top

      this.inView = rect.bottom > 0 && (elTop - windowHeight) < 0
      this.inViewMostly = rect.bottom > 0 && (elTop - windowHeight) < 0 - (windowHeight / 3)
    }
  },
  created () {
    window.addEventListener('load', () => {
      this.onScroll()
      this.onScrollDirect()
    })
    windowUtil.addScrollListener(this.onScroll, 300)
    windowUtil.addScrollListener(this.onScrollDirect, 50)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/scrollPositionMixin.js